import React, { useState } from "react";
import { Row, Col, Modal, Form, Button } from "react-bootstrap";
import OrgPickerModal from "organizations/OrgPickerModal";
import jsDig from "utils/jsDig";

export default function ProfileDropdown(props) {
  let logout = require("images/lite/icons/logout.png");
  logout = <img className="logout-icon" style={{ paddingBottom: "3px", paddingRight: "12px" }} src={`/datapulse${logout}`} />;
  let dpLogo = require("images/logos/dp-logo-white.png");
  dpLogo = <img width="40" height="40" className="avatar-picker" style={{ paddingBottom: "3px", paddingRight: "1px" }} src={`/datapulse${dpLogo}`} />;
  let orgLogo = props.logo ? props.logo : "";
  orgLogo = <img width="40" hieght="40" className="avatar-picker" style={{ paddingBottom: "3px", paddingRight: "1px" }} src={`${orgLogo}`} />;

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

  const [showOrgOptions, setShowOrgOptions] = useState(false);
  const toggleOrgOptions = () => setShowOrgOptions(!showOrgOptions);
  const userOrgDetail = props.user_org_details.find((el) => el.organization_id == jsDig(["selected_org", "id"], props));
  const getRoleTitle = (role) => {
    switch (role) {
      case "admin":
        return "Admin";
      case "manager":
        return "Full";
      case "specialist":
        return "Standard";
      case "employee":
        return "Restricted";
      case "client":
        return "Client";
      default:
        return "Nobody";
    }
  };
  let dropdownArrow = require("images/lite/icons/chevron-down.png");
  dropdownArrow = <img className="dropdown-arrow" src={`/datapulse${dropdownArrow}`} style={{ transform: showOrgOptions ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }} />;

  return (
    <div className="profile-dropdown">
      {(props.organizations && props.organizations.length) > 0 && props.current_user_is_god && (
        <>
          <p className="mb-2 f10 text-right org-settings-dropdown" onClick={(e) => {e.stopPropagation(); toggleOrgOptions()}}>
            Organization: <b>{props.selected_org ? props.selected_org.name : "None"}</b>
            <span className="f10 text-info ml-1">
              {dropdownArrow}
            </span>
          </p>
          <Row className={`top mx-0 my-2 org-settings ${showOrgOptions ? "expanded" : ""}`}>
            <Col className="pb-2">
              <Row className="py-2">
                <Col>
                  <Row>
                    <Col xs={3}>{props.logo ? orgLogo : dpLogo}</Col>
                    <Col>
                      <Row>
                        <Col>
                          <p style={{ whiteSpace: "nowrap" }} className="f16">
                            {props.selected_org ? props.selected_org.name : "None"}
                          </p>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <p className="f12">{getRoleTitle(jsDig(["role"], userOrgDetail))}</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col xs={4}></Col>
              </Row>
              {props.organizations.length > 1 && (
                <p onClick={handleShow} style={{ whiteSpace: "nowrap" }} className="f14 profile-dropdown-item text-info">
                  Change Organization
                </p>
              )}
              {(getRoleTitle(jsDig(["role"], userOrgDetail)) === "Admin" || props.current_user_is_god) && (
                <a
                  className="f14 profile-dropdown-item text-info"
                  href={window.location.origin + "/datapulse/organization/" + jsDig(["selected_org", "id"], props)}>
                  Organization Settings
                </a>
              )}
            </Col>
          </Row>
        </>
      )}
      <Row className="bot mx-0">
        <Col>
          <p className="dropdown-name">
            {props.current_user.first_name} {props.current_user.last_name}
          </p>
          <a href={window.location.origin + "/datapulse/profile"} style={{ lineHeight: "1.75" }} className="f14 profile-dropdown-item dropdown-text">
            My Profile
          </a>
          <br></br>
          {(["Standard", "Full", "Admin"].includes(getRoleTitle(jsDig(["role"], userOrgDetail)))) && (
            <>
              <a href={window.location.origin + "/datapulse/alerts"} style={{ lineHeight: "1.75" }} className="f14 profile-dropdown-item dropdown-text">
                Alerts
              </a>
            </>
          )}
          <hr></hr>
          {(getRoleTitle(jsDig(["role"], userOrgDetail)) == "Admin" || props.current_user_is_god) && (
            <>
              <p className="dropdown-name">Admin</p>
              <a href={window.location.origin + "/datapulse/user-access"} style={{ lineHeight: "1.75" }} className="f14 profile-dropdown-item dropdown-text">
                User Access
              </a>
              <br></br>
              <a
                href={window.location.origin + "/datapulse/client-management"}
                style={{ lineHeight: "1.75" }}
                className="f14 profile-dropdown-item dropdown-text">
                Client Management
              </a>
              <br></br>
              <a href={window.location.origin + "/datapulse/api-access"} style={{ lineHeight: "1.75" }} className="f14 profile-dropdown-item dropdown-text">
                API Access
              </a>
              <br></br>
              <hr></hr>
            </>
          )}
          <a className="f14 profile-dropdown-item dropdown-text" rel="nofollow" data-method="delete" href={props.logout_path}>
            {logout}Logout
          </a>
        </Col>
      </Row>
      {props.organizations && props.organizations.length > 0 && (
        <OrgPickerModal show={show} setShow={setShow} selectedOrg={props.selected_org} organizations={props.organizations} />
      )}
    </div>
  );
}
